const FONT_BASE = {
  HOST:
    'https://s3.amazonaws.com/tr-prod-assets/web/font/CT0199-GibsonWOFF/Gibson-',
  FAMILY: 'Gibson',
  FORMAT: 'woff'
};

const FONT_BASE_OMP = {
  FAMILY: 'Heebo'
};

const fonts = {
  GIBSON: {
    FAMILY: FONT_BASE.FAMILY,
    SRC: `${FONT_BASE.HOST}Regular-webfont.woff`,
    FORMAT: 'woff'
  },
  GIBSON_LIGHT: {
    FAMILY: `${FONT_BASE.FAMILY}Light`,
    SRC: `${FONT_BASE.HOST}Light-webfont.woff`,
    FORMAT: FONT_BASE.FORMAT
  },
  GIBSON_SEMI_BOLD: {
    FAMILY: `${FONT_BASE.FAMILY}SemiBold`,
    SRC: `${FONT_BASE.HOST}SemiBold-webfont.woff`,
    FORMAT: FONT_BASE.FORMAT
  },
  HEEBO: {
    FAMILY: FONT_BASE_OMP.FAMILY
  },
  HEEBO_BOLD: {
    FAMILY: `${FONT_BASE_OMP.FAMILY}Bold`
  },
  POPPINS: {
    FAMILY: 'Poppins'
  }
};

export default fonts;
